import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { SmartButton } from "@mui/icons-material";
import { TextField, responsiveFontSizes } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
    setState,
} from "../scenarioSetupNewSlice";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../../../components/ui/CustomButton";

const ScenarioValidationPopUp = () => {
  const dispatch = useDispatch();
  const setupState = useSelector((store) => store.scenarioSetupNew);
  const {
    openScenarioPopUp,errorList,errorMessage
  } = setupState;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const onClose = () => {
    dispatch(setState("openScenarioPopUp", false));
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = errorList.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <div>
      <Dialog
        open={openScenarioPopUp}
        fullWidth
        maxWidth={"md"}
      >
        <DialogTitle
          sx={{ fontSize: "18px", fontWeight: "700", color: "#FF0000" }}
        >
          Invalid Scenario

        <Button
                className="closeButton"
                sx={{float: "right", minWidth: "30px !important", ml: 4, }}
                startIcon={
                  <CloseIcon
                    sx={{ color: "black.main", minWidth: "10px !important" }}
                  />
                }
                onClick={onClose}
        ></Button>
        </DialogTitle>

        <DialogContent>
        <Typography sx={{ fontWeight: "600" }} display="inline">
             {errorMessage}
        </Typography>

          <Box sx={{ mb: 1.2, pt: 2 }}>
            <Paper>
              <TableContainer
                style={{
                  maxHeight: "calc(100vh - 330px)",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <Table
                  component={Paper}
                  style={{ overflowY: "scroll", overflowX: "hidden" }}
                  stickyHeader
                  // sx={{ minWidth: 750 }}
                  // aria-labelledby="tableTitle"
                  // size={'large'}
                >

                  <TableBody>
                    {errorList?.map((row, index) => {
                      //const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <>
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            sx={{ cursor: "pointer" }}
                          >
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                            >
                              {row}
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* <TablePagination
                rowsPerPageOptions={[20, 50, 100]}
                component="div"
                count={errorList?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              /> */}
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions>
          <CustomButton
            onClick={onClose}
            color="primary"
            variant={"outlined"}
            sx={{ marginBottom: "10px",marginRight: "12px" }}
          >
            Ok
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ScenarioValidationPopUp;
